import styled from "styled-components";

export const ButtonAnnex = styled.div`
  display: flex;
  justify-content: center;
  gap: 28px;
`;
